import { DialogueUIOptionConfig } from "../../components/ui/YouRespondUI";
import { NurseStationComputerUIConfig } from "../../components/ui/NurseStationComputerUI";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { Segments } from "../../cvp-webgames-core/Scenario/Segments";
import { constants } from "../../misc/constants";
import { CalmBaseScenario, ScoreType, Window508Type } from "../CalmBaseScenario";
import Scenario3 from "./Scenario3";

export default class Scenario3Part2 extends BaseScenarioPart<CalmBaseScenario> {

	private partIndx = 1;
	
	chapterIds = {
		scenario3_2a_s5: 'CALM - Scenario 3 - 2A - Segment 5',
		scenario3_2a_s6: 'CALM - Scenario 3 - 2A - Segment 6',
		scenario3_2a_s7: 'CALM - Scenario 3 - 2A - Segment 7',
		scenario3_2a_s8: 'CALM - Scenario 3 End - 2A - Segment 8'
	}

	constructor(scenario: Scenario3, private onDone: () => void) {
		super(scenario);
		CalmBaseScenario.partIndx = this.partIndx;
	}

	public get videoUrl(): string[] {
		return ['./assets/videos/scenario3/calm-scenario3-avatar' + this.scenario.avatarIndx + '.mp4'];
	}

	public get partId(): string {
		return constants.scenarios.scenario3.parts.level3Part2.id;
	}

	public start() {
		const context = this;
		context.segment1Step1MirandaApproaches();

	}

	private segment1Step1MirandaApproaches() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.displayHeader();
		context.playVideoChapter(this.chapterIds.scenario3_2a_s5, () =>
			context.segment1Step2Dialogue())
	}

	private segment1Step2Dialogue() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.dialog(
			'CN-C08-L2-000a',
			[{
				text: 'Let’s look up our facility’s policies on transfusions.',
				scoreType: ScoreType.Best,
				isCorrect: true // Rank best
			}, {
				text: 'Can I help you later?',
				feedback: 'Blood transfusions are very time-sensitive. You need to prioritize getting her the resources she needs.',
				scoreType: ScoreType.Worst,
				isCorrect: false // Rank worst
			}, {
				text: 'Sure! I can help you now!',
				feedback: 'Before helping RN Miranda, you should remind her of your facility’s policies. Each VA may have different policies on blood transfusions, and you need to be certain that RN Miranda understands these policies, so she can be better prepared in the future.',
				scoreType: ScoreType.Worst,
				isCorrect: false
			}],
			(selectedOption: DialogueUIOptionConfig) => {
				selectedOption.hide = true; // set hide here				
				context.scenario.evaluateAnswer(selectedOption, () => 
				context.segment2aStep1PolicyCheck(), 
				context.partIndx);
				
			}
		);
		context.scenario.updateObjective('Select your response to Miranda');
	}

	private segment2aStep1PolicyCheck() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('Show Miranda the transfusion policies');
		context.playVideoChapter(context.chapterIds.scenario3_2a_s6, () => {
		context.scenario.updateObjective('');
		context.segment2aStep2ComputerResearch();
		});
	}

	private segment2aStep2ComputerResearch() { // This interaction is just a scrollable text field with text		
		var context = this;
		context.scenario.update508Window(Window508Type.NurseStationComputerUI);
		const instanceId = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.NurseStationComputerUI, {
			reports: null,
			review: { 
				text:
					`
					<p class="regular-description-font" style="margin: 0">
					BLOOD TRANSFUSION POLICY<br />
					
						<ul>
							<li>
								<span style="color: rgb(222, 225, 156)"> (1) Prep the patient for transfusion</span><br /> <br />
								<span style="position: relative; left: 14px">A. Check patient consent.</span><br /><br />
								<span style="position: relative; left: 14px">B. Check patient for patent IV.</span><br /><br />
							</li>

							<li>
								<span style="color: rgb(222, 225, 156)"> (2) Retrieve blood.<br /><br />
							</li>

							<li>
								(3) - (9) : Refer to your local Blood Transfusion Policy<br /><br />
							</li>
							
							<li>
								(10) Take vital signs after transfusion completed</span><br /><br />
							</li>
						</ul>
					</p>
					`
			},
			reflects: null,
			onClosed: (config: NurseStationComputerUIConfig) => {
				context.scenario.update508Window(Window508Type.Main);
				context.scenario.gameManager.UiManager.destroyUIInstanceById(instanceId);
				context.segment2bstep1PolicyCheckEnd();
			}
		})
	}

	private segment2bstep1PolicyCheckEnd() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.playVideoChapter(context.chapterIds.scenario3_2a_s7, () => {
			context.segment2bStep2Dialogue();
		});
	}

	private segment2bStep2Dialogue() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.dialog(
			'CN-C08-L2-010b',
			[{
				text: 'You’ll have to first prep the patient for the transfusion.',
				scoreType: ScoreType.Best,
				isCorrect: true // Rank best
			}, {
				text: 'I’ll prep the patient for you while you get the blood.',
				feedback: 'In her preceptorship, RN Miranda would have successfully prepped many patients for blood transfusions. Instead of doing this step for her, she should do it on her own. However, you or another experienced RN will have to step in and assist her for the actual transfusion.',
				scoreType: ScoreType.Worst,
				isCorrect: false // Rank worst
			}],
			(selectedOption: DialogueUIOptionConfig) => {
				selectedOption.hide = true; // set hide here				
				context.scenario.evaluateAnswer(selectedOption, () => 
				context.segment3Step1MirandaDeparts(), 
				context.partIndx);
				
			}
		);
		context.scenario.updateObjective('Select your response to Miranda');
	}


	private segment3Step1MirandaDeparts() {
		this.scenario.destroyAllUIInstances();
		var context = this;		
		context.scenario.updateObjective('');
		context.playVideoChapter(this.chapterIds.scenario3_2a_s8, () => {			
			context.onDone();
		});
	}	
}